import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { BookingAttachmentFile } from '../booking-attachment-file';
import { GmailMessageWithBookingFiles } from '../gmail-message-with-booking-files';
import { HttpService } from '../service/http.service';
import { BookingEmailService } from '../service/booking-email.service';
import { BookingService } from '../service/booking.service';
import { EmailSignatureService } from '../service/email-signature.service';
import { ToastMessageService } from '../toast-message.service';
import * as Editor from '../../libs/ckeditor';
import { environment } from 'src/environments/environment';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-booking-email',
  templateUrl: './booking-email.component.html',
  styleUrls: ['./booking-email.component.css']
})
export class BookingEmailComponent implements OnInit {

  displayFileAttachmentDialog = false;
  attachmentLoading = false;
  @Input("isEmailToStudent") isEmailToStudent!: boolean;
  colors: string[] = environment.backgroundColors;

  public Editor = Editor;

  constructor(
    public bookingEmailService: BookingEmailService,
    public emailSignatureService: EmailSignatureService,
    public bookingService: BookingService,
    private httpService: HttpService,
    private toastService: ToastMessageService,
    private builder: FormBuilder
  ) { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  get recipients(): FormArray {
    return this.bookingEmailService.emailForm.get("recipients") as FormArray;
  }

  checkValue() {
    console.log(this.recipients);
  }

  activateEmailDialog() {
    this.bookingEmailService.displayMailingDialog = true;
    this.bookingEmailService.emailAttachmentFiles = [];
    this.bookingEmailService.loadEmailTemplate(this.bookingService.booking.student.language.id);
  }

  sendEmailToClient() {
    let recipients = this.getEmailRecipients();
    if (recipients.length == 0 || !recipients) {
      this.toastService.addError("Error", "Please select at least one email address");
      this.bookingEmailService.emailSending = false;
      return;
    }
    let message = new GmailMessageWithBookingFiles(
      recipients,
      this.bookingEmailService.emailForm.value.subject,
      this.bookingEmailService.emailForm.value.body,
      this.bookingEmailService.emailAttachmentFiles,
      this.bookingEmailService.emailForm.value.signature.language.id,
      this.bookingService.booking.id!,
      false,
      this.bookingEmailService.emailForm.value.backgroundColor
    );

    this.sendEmailMessageToServer(message);
    this.bookingEmailService.emailSending = true;
  }

  sendEmailMessageToServer(message: GmailMessageWithBookingFiles) {
    this.httpService.sendHtmlEmailByGoogole(message, this.bookingEmailService.emailForm.value.withPastePixel).subscribe(res => {
      this.toastService.addSuccess("Success", "Email sent");
      this.bookingEmailService.displayMailingDialog = false;
      this.bookingEmailService.emailSending = false;
      this.bookingEmailService.emailAttachmentFiles = [];
    }, error => {
      this.toastService.addError("Error", error.error);
      this.bookingEmailService.emailSending = false;
    });
  }

  removeAttachment(file: BookingAttachmentFile) {
    this.bookingEmailService.emailAttachmentFiles.splice(this.bookingEmailService.emailAttachmentFiles.indexOf(file), 1);
  }

  closeEmailDialog() {
    this.bookingEmailService.displayMailingDialog = false;
    this.bookingEmailService.emailAttachmentFiles = [];
  }

  initStudentContacts() {
    if (this.bookingService.booking.student.email) {
      this.recipients.controls.push(this.builder.group({
        email: this.bookingService.booking.student.email,
        isSelected: false,
        typeName: this.bookingService.booking.student.primaryContactType.name
      }));
    }
    for (let studentContact of this.bookingService.booking.student.contacts) {
      if(studentContact.email){
        this.recipients.controls.push(this.builder.group({
          email: studentContact.email,
          isSelected: false,
          typeName: studentContact.type.name
        }));
      }
    }
  }

  getEmailRecipients() {
    let recipients: string[] = [];
    for (let recipient of this.recipients.controls) {
      if (recipient.value.isSelected) {
        recipients.push(recipient.value.email);
      }
    }
    return recipients;
  }

  testCommunication() {
    this.httpService.testErrorMessage().subscribe(() => {
      console.log("success");
    }, error => {
      console.log(error);
      console.log(error.error);
    });
  }

  get recipientsFormArray() {
    let formArray = this.bookingEmailService.emailForm.get('recipients') as FormArray;
    return formArray.controls;
  }

  updateBackgroundColor(value: string | null) {
    this.bookingEmailService.emailForm.get("backgroundColor")?.setValue(value);
  }

  showValue() {
    console.log(this.bookingEmailService.emailForm.get("body")!.value);
    console.log(this.Editor);
  }

  openTemplateEditComponent() {
    let templateId = this.bookingEmailService.loadedTemplate?.id;
    window.open(environment.sbmsBaseUrl + "/management/edit-booking-email-template/" + templateId, "_blank");
  }

}
